import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Rubric cells are shaded in the table below by suggested level of oversight, with darker shading corresponding to a
greater need for oversight. Note that only half of respondents who used framework A were provided with this rubric.
Results for the two groups are differentiated in the Results tab.`}</p>
    <Table mdxType="Table">
    <TableHead mdxType="TableHead">
        <TableRow mdxType="TableRow">
            <TableCell mdxType="TableCell"></TableCell>
            <TableCell colSpan="3" style={{
            fontWeight: "bold"
          }} mdxType="TableCell">Impact</TableCell>
        </TableRow>
    </TableHead>
    <TableBody mdxType="TableBody">
        <TableRow mdxType="TableRow">
            <TableCell style={{
            fontWeight: "bold"
          }} mdxType="TableCell">Autonomy</TableCell>
            <TableCell mdxType="TableCell">High</TableCell>
            <TableCell mdxType="TableCell">Medium</TableCell>
            <TableCell mdxType="TableCell">Low</TableCell>
        </TableRow>
        <TableRow mdxType="TableRow">
            <TableCell mdxType="TableCell">High</TableCell>
            <TableCell style={{
            "backgroundColor": "rgb(86,134,186)"
          }} mdxType="TableCell">System evaluates input and executes decision without human involvement. Decision could lead to death or serious risk to national security, civil rights, or enterprise functions.</TableCell>
            <TableCell style={{
            "backgroundColor": "rgb(123,168,216)"
          }} mdxType="TableCell">System evaluates input and executes decision without human involvement. Decision could lead to mitigable risk to network security, personal livelihood, or enterprise functions.</TableCell>
            <TableCell style={{
            "backgroundColor": "rgb(166,197,229)"
          }} mdxType="TableCell">System evaluates input and executes decision without human involvement. Decision has little to no risk for security, rights, or enterprise functions.</TableCell>
        </TableRow>
        <TableRow mdxType="TableRow">
            <TableCell mdxType="TableCell">Medium</TableCell>
            <TableCell style={{
            "backgroundColor": "rgb(123,168,216)"
          }} mdxType="TableCell">System evaluates input and makes recommendation for human decision execution. Decision could lead to death or serious risk to national security, civil rights, or enterprise functions.</TableCell>
            <TableCell style={{
            "backgroundColor": "rgb(166,197,229)"
          }} mdxType="TableCell">System evaluates input and makes recommendation for human decision execution. Decision could lead to mitigable risk to network security, personal livelihood, or enterprise functions.</TableCell>
            <TableCell style={{
            "backgroundColor": "rgb(210,226,291)"
          }} mdxType="TableCell">System evaluates input and makes recommendation for human decision execution. Decision has little to no risk for security, rights, or enterprise functions.</TableCell>
        </TableRow>
        <TableRow mdxType="TableRow">
            <TableCell mdxType="TableCell">Low</TableCell>
            <TableCell style={{
            "backgroundColor": "rgb(166,197,229)"
          }} mdxType="TableCell">System evaluates input and flags information for human decision execution. Decision could lead to death or serious risk to national security, civil rights, or enterprise functions.</TableCell>
            <TableCell style={{
            "backgroundColor": "rgb(210,226,291)"
          }} mdxType="TableCell">System evaluates input and flags information for human decision execution. Decision could lead to mitigable risk to network security, personal livelihood, or enterprise functions.</TableCell>
            <TableCell style={{
            "backgroundColor": "rgb(239,239,239)"
          }} mdxType="TableCell">System evaluates input and flags information for human decision execution. Decision has little to no risk for security, rights, or enterprise functions.</TableCell>
        </TableRow>
        <TableRow mdxType="TableRow">
            <TableCell mdxType="TableCell">No</TableCell>
            <TableCell style={{
            "backgroundColor": "rgb(210,226,291)"
          }} mdxType="TableCell">System requires human evaluation of input and decision execution. Decision could lead to death or serious risk to national security, civil rights, or enterprise functions.</TableCell>
            <TableCell style={{
            "backgroundColor": "rgb(239,239,239)"
          }} mdxType="TableCell">System requires human evaluation of input and decision execution. Decision could lead to mitigable risk to network security, personal livelihood, or enterprise functions.</TableCell>
            <TableCell mdxType="TableCell">System requires human evaluation of input and decision execution. Decision has little to no risk for security, rights, or enterprise functions</TableCell>
        </TableRow>
    </TableBody>
    </Table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      